import { render } from "./TopBar.vue?vue&type=template&id=53fb835d"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"
script.render = render

export default script